// extracted by mini-css-extract-plugin
export var externalLink = "_c0-0";
export var internalLinkLabel = "_c0-1";